__webpack_require__.p = "https://app-staticfiles.blr1.cdn.digitaloceanspaces.com/talent/prod/releases/1-20260722-1122/";